<template>
    <div class="listmain ">
        <h1 class="firTitle">快速创建专属技能</h1>
              <p>本文档旨在教您快速创建一个自定义技能, 通过重要概念说明您可以更好地了解专业名词.
              </p>
              <h3 class="sedTitle">1.登录OrionOS开放平台</h3>
              <p>使用OrionOS开放平台的功能,需要先注册OrionOS开发者账号.如需发布上线,请登录账号后完成开发者认证.
              </p>
              <h3 class="sedTitle">2.技能设计思想</h3>
              <p>在创建技能之前,您需要了解目标用户的常用交互场景和交互流程. 如何更好地设计语应用, 请参照语音设计思想
              </p>
              <h3 class="sedTitle">3.创建自定义技能</h3>
              <p>技能是用户进行语音交互的基本单位.
                <br> 登录OrionOS开放平台后,在导航栏点击"控制台",在技能列表中,点击"+创建技能", 填写技能基本资料.
                <br> 技能类型:默认自定义类型
                <br> 技能名称:技能展示到技能商店的名称,不可重复
                <br> 技能标识:技能的唯一调用标识,不可重复.
                <br> 技能分类:合理定义技能类别有利于用户和开发者方便找到技能,提升技能曝光率
                <br> 技能图标:展示到技能商店的LOGO,是技能的图形品牌形象
                <br> 技能介绍:对技能进行简要介绍,便于用户更直观的了解技能的使用场景和用处
                <br>
              </p>
              <img src="../../../static/images/skillTutor/createSkill.png" alt="img" class="createSkillImg">
              <h3 class="sedTitle">4.创建意图</h3>
              <p>一个语音技能包含多个用户的意图, 每个意图描述了用户的一种使用场景. 如查询天气技能, 包含获取温度,获取下雨信息,获取空气质量,获取下雪信息,获取湿度信息等
                <br> 意图中文名: 意图中文名称
                <br> 意图标识名: 意图调用名称
                <br>

              </p>
              <img src="../../../static/images/skillTutor/createIntention.png" alt="img" class="createIntentionImg">

              <p>常用表达: 用户使用场景中常用的表达方式. 如查询天气"帮我查一下今天的天气, 查一下上海明天的天气, 查一下天气等"
              </p>
              <img src="../../../static/images/skillTutor/example.png" alt="img" class="exampleImg">
              <p>
                意图(intent)：代表用户对领域数据的操作，如查询、查询某一个属性的值、预订、拨打等。一般以动词命名。
                <br> 槽位列表(slots)：描述意图的数据（键值对的集合），也是实现意图所需要的参数。
                <br> 意图确认: 用户选填项, 其含义为所有槽位填满后,自动向用户发起一次问询以帮助用户进行二次意图确认. 常用在敏感意图(如涉及缴费, 删除等敏感操作)
              </p>
              <p>
                多轮对话:
                <br> 多轮对话共分为两大类
                <br> A:基于槽位的多轮对话,旨在帮助用户填满槽位.在槽位中的追问语句即此含义.
                <br> B:基于上下文的多轮对话,旨在透过用户上文意图,挖掘本轮意图.简化对话流程. 基于上下文的多轮对话又分为当前意图不涉及槽位添加的多轮对话(如: 帮我查询今天北京的天气. 上海呢? ).  意图涉及槽位添加的多轮对话(如:我想听一首刘德华的歌曲. 我想听一首更深情的.)
                <br> 使用此功能可以在"前置意图"中选择要引用的前置意图, 并在新增槽位中"值"里引用.
              </p>

              <h3 class="sedTitle">5.创建字典</h3>
              <p>
                字典是为名词创建一一对应关系的词表. 如"北京"对应"北平,帝都,首都". 字典支持批量导入导出功能.
              </p>
              <img src="../../../static/images/skillTutor/createDic.png" alt="img" class="createDicImg">
              <p>
                字典文件要求:
                <br> 文件大小:不超过10M
                <br> 文件类型:CSV文件
                <br> 文件编码:utf8编码
              </p>
              <p>
                模板：
              </p>
              <table>
                <tr>
                  <th>填写词</th>
                  <th>同义词</th>
                  <th></th>
                  <th></th>
                </tr>
                <tr>
                  <td>北京</td>
                  <td>北平</td>
                  <td>帝都</td>
                  <td>首都</td>
                </tr>
                <tr>
                  <td>上海</td>
                  <td>魔都</td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
              <h3 class="sedTitle">6.配置服务</h3>
              <p>
                猎户语音开放平台服务采用WebService进行部署，且不限制部署环境，开发者可以自行进行选择托管于公有云或自行部署。开发者最终需要提供用户技能服务的处理网关，猎户语音系统会将所有的请求转发到该网关。部署完毕，当前端用户使用语音进入开发者的技能后，后端服务会将该语音链路请求转换为语音链路描述转发到配置的技能网关
              </p>
              <img src="../../../static/images/skillTutor/service.png" alt="img" class="serviceImg">
              <h3 class="sedTitle">7.在线测试</h3>
              <p>
                用户可以通过, 打开调用名称, 如"打开天气查询". 对当前技能进行测试.
              </p>
              <img src="../../../static/images/skillTutor/test.png" alt="img"  class="testImg">

              <h3 class="sedTitle">8.技能发布</h3>
              <p>
                当技能构建完成,同时测试通过后,可以通过技能发布,让市场中的用户使用. 技能发布后除非撤销审核将不可编辑. 技能审核通过后, 将发布到技能商店. 供市场中的用户使用.
              </p>
              <img src="../../../static/images/skillTutor/release.png" alt="img" class="releaseImg">
              <h3 class="sedTitle">9.技能更新</h3>
              <p>
                发布后的技能不可编辑修改, 需要在技能概览-版本管理中点击"更新", 将创建一份新的开发副本, 用户可以进行编辑. 上线需要重新走上线审核流程

              </p>

    </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 26px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
  }
  .createSkillImg{
    height:500px;
  }
  .createIntentionImg{
    height: 250px;
  }
  .exampleImg{
    height: 350px;
  }
  .createDicImg{
    height: 600px;
  }
  .serviceImg{
    height: 220px;
  }
  .testImg{
    width: 766px;
    height: 483px;
  }
  .releaseImg{
    height: 650px;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/tutor/zdyjn_ks.vue